export class User {

  constructor (
      public email: string,
      public cognitoUser: any,
  ) { }

}

